<template>
	<div class="nocopy">
		<template :class="{ loading: true, hide: !isLoading, show: isLoading }">
			<breeding-rhombus-spinner class="loading-component" :animation-duration="2000" :size="65" color="#0680C7" />
			<div id="titleLoading">
				<i class="fa-solid fa-graduation-cap"></i> Techbim
			</div>
		</template>
		<template id="appMain" :class="{ hide: isLoading, show: !isLoading }">
			<TrackingOnline />
			<router-view></router-view>
			<CommonNotification></CommonNotification>
		</template>
	</div>
</template>
<script>

import CommonNotification from '@/components/common/CommonNotification'
import { BreedingRhombusSpinner } from 'epic-spinners';
import useEventBus from '@/composables/useEventBus'
import TrackingOnline from '@/components/TrackingOnline.vue'
const { onEvent } = useEventBus()

export default {
	name: 'App',
	components: {
		CommonNotification,
		BreedingRhombusSpinner,
		TrackingOnline
	},
	setup() {
		document.title = "Techbim";
	},
	data() {
		return {
			isLoading: false,
			turnOn: true, // chỉnh thành false để code, nào deploy thì chỉnh thành true
		}
	},
	onMouseDown(e) {
		if(this.turnOn === true) {
			// chặn click phải
			if (e.button === 2) e.preventDefault();
		}
	},
	mounted() {
		onEvent('eventLoading', (isLoading) => {
			this.isLoading = isLoading;
		})

		if(this.turnOn === true) {
			// chặn contextmenu toàn cục
			window.addEventListener('contextmenu', (e) => e.preventDefault(), { capture: true });
			// chặn phím tắt
			window.addEventListener('keydown', this.blockKeys, { capture: true });
		} 
	},
	beforeUnmount() {
		if(this.turnOn === true) {
			window.removeEventListener('keydown', this.blockKeys, { capture: true });
		}
	},
	methods: {
		blockKeys(e) {
			const key = e.key?.toLowerCase?.();
			// Ctrl+Shift+I hoặc Ctrl+Shift+J (devtools)
			if (e.ctrlKey && e.shiftKey && (key === 'i' || key === 'j')) {
				e.preventDefault(); return;
			}
			// Ctrl+U (view source), Ctrl+S (save page)
			if ((e.ctrlKey || e.metaKey) && (key === 'u' || key === 's')) {
				e.preventDefault(); return;
			}
			// Shift+F10 (mở context menu)
			if (e.shiftKey && e.key === 'F10') {
				e.preventDefault(); return;
			}
			// Kiểm tra nếu nhấn phím F12
			if (e.keyCode === 123) { // 123 là mã của phím F12
				e.preventDefault(); // Ngăn hành động mặc định (mở DevTools)
				console.log("F12 key blocked.");
			}
			// Kiểm tra nếu nhấn tổ hợp Ctrl + Shift + I
			if (e.ctrlKey && e.shiftKey && e.keyCode === 73) { // 73 là mã phím "I"
				e.preventDefault(); // Ngăn hành động mặc định (mở DevTools)
				console.log("Ctrl+Shift+I blocked.");
			}
		},
	},
	watch: {

	},
}
</script>
<style src="@/components/app-responsive.css"></style>
<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');
</style>
<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

* {
	font-family: "Roboto", sans-serif;
}

/* #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} */

/* Trong file global CSS */
.nocopy {
	user-select: none;
	/* Không cho bôi đen */
}

img {
	user-select: none;
	-webkit-user-drag: none;
	pointer-events: auto;
}

/* Trong file global CSS */

html {
	scroll-behavior: smooth;
}

li {
	list-style: none;
}

a {
	text-decoration: none;
}

body {
	background-color: #F0F2F5 !important;
}

:root {
	--user-color: #0680c7;
	--admin-color: #06C755;
	--blue-color: #007BFF;
	--brown-color: #8B4513;
	--yellow-color: #c0b01d;
	--btn-hover: 0px 15px 20px #8fbefb;
}

::-webkit-scrollbar {
	height: 12px;
	width: 12px;
}

::-webkit-scrollbar-track {
	background: white;
}

::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 10px;
	border: 3px solid transparent;
	background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
	background: var(--user-color);
	border-radius: 10px;
	border: 3px solid transparent;
	background-clip: content-box;
}

#view {
	display: grid;
	width: 100%;
	overflow-y: scroll;
}

#view::-webkit-scrollbar {
	display: none;
}

#view {
	-ms-overflow-style: none;
	scrollbar-width: none;
}

.modal-open .modal {
	background-color: #0000008a;
}

.btn {
	outline: none;
}

button {
	outline: none !important;
}

.loading-component {
	margin: auto;
	margin-top: 300px;
}

#titleLoading {
	margin-top: 25px;
	text-align: center;
	font-weight: bold;
	color: var(--user-color);
}

#titleLoading {
	animation: titleLoading 2s linear infinite;
}

@keyframes titleLoading {
	50% {
		opacity: 0;
	}
}

.hide {
	display: none;
}

.show {
	display: block;
}

.btn-pers {
	position: relative;
	left: 50%;
	padding: 1em 2.5em;
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: 2.5px;
	font-weight: 700;
	color: #000;
	background-color: #fff;
	border: none;
	border-radius: 45px;
	box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease 0s;
	cursor: pointer;
	outline: none;
	transform: translateX(-50%);
}

.btn-pers:hover {
	background-color: var(--user-color);
	/* box-shadow: 0px 15px 20px #80ffb5; */
	box-shadow: var(--btn-hover);
	color: #fff;
	transform: translate(-50%, -7px);
}

.btn-pers:active {
	transform: translate(-50%, -1px);
}

button.close span {
	color: black !important;
	transition: color 0.5s ease !important;
}

button.close:hover span {
	color: red !important;
	transition: color 0.5s ease !important;
}

.color-header {
	color: var(--user-color);
}


/* Upload file */
.close-img {
	position: absolute;
	top: -6px;
	/* left: 6px; */
	right: 6px;
	width: 16px;
	cursor: pointer;
}

.container-file-default {
	position: relative;
}

/* Upload file */

.uppercase {
	text-transform: uppercase;
}

.bold {
	font-weight: bold;
}

.fw-500 {
	font-weight: 500;
}
</style>
